<template>
  <v-container fluid>
    <v-card class="pb-2">
      <v-card-title>Отзывы</v-card-title>

      <!-- Селекторы -->
      <v-form ref="form">
        <v-card-text>
          <v-row>
            <!-- Дата -->
            <v-col cols="12" sm="6" md="4">
              <date-time-picker v-model="date" />
            </v-col>

            <!-- тип даты (озыв/звонок) -->
            <v-col cols="12" sm="6" md="4">
              <Carusel-Button
                ref="period_type"
                label="По дате"
                :type="'general'"
                :items="[
                  {name: 'Отзыва', id: 'creation_period'},
                  {name: 'Звонка', id: 'call_period'},
                ]"
                :getVal="getValPeriodType"
                style="margin-top:17px;"
              />
            </v-col>

            <!-- Проекты -->
            <v-col cols="12" sm="6" md="4">
              <ProjectSelector v-model="projects" />
            </v-col>

            <!-- Тип отзыва -->
            <v-col cols="12" sm="6" md="4">
              <custom-select
                v-model="complaintsTypes"
                :items="questionnaires"
                :loading="questionnairesLoading"
                item-text="label"
                chip-text="label"
                item-value="id"
                label="Тип отзыва"
                multiple
              />
            </v-col>

            <!-- Операторы -->
            <v-col cols="12" sm="6" md="4">
              <UserSelector v-model="agents" noRules @loaded="filtersFromQuery"/>
            </v-col>

            <!-- Автор отзыва -->
            <v-col cols="12" sm="6" md="4">
              <UserSelector v-model="authors" noRules label="Автор отзыва" />
            </v-col>

            <!-- Продолжительность -->
            <v-col cols="12" sm="6" md="4">
              <v-row class="mt-0 pl-3">
                <span>Продолжительность (сек.)</span>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-text-field
                    v-model="duration.from"
                    hide-details
                    single-line
                    prefix="От"
                    type="number"
                  />
                </v-col>

                <v-col cols="6" class="pl-2">
                  <v-text-field
                    v-model="duration.to"
                    hide-details
                    single-line
                    prefix="До"
                    type="number"
                  />
                </v-col>
              </v-row>
            </v-col>

            <!-- Балл КЛН -->
            <v-col cols="12" sm="6" md="4">
              <v-row class="mt-0 pl-3">
                <span>Балл КЛН</span>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-text-field
                    v-model="klnScore[0]"
                    hide-details
                    single-line
                    prefix="От"
                    type="number"
                    min="0"
                    max="100"
                  />
                </v-col>

                <v-col cols="6" class="pl-2">
                  <v-text-field
                    v-model="klnScore[1]"
                    hide-details
                    single-line
                    prefix="До"
                    type="number"
                    min="0"
                    max="100"
                  />
                </v-col>
              </v-row>
            </v-col>

            <!-- Только переведённые -->
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                v-model="onlyTransfered"
                hide-details
                class="ma-0"
                label="Только переведённые"
              />
              <!-- <v-checkbox
                v-model="onlyMining"
                hide-details
                class="ma-0"
                label="Только отработанные"
              /> -->
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <Carusel-Button
                label="Источник"
                :type="'general'"
                :items="[
                  {name: 'Все', id: null},
                  {name: 'РГ', id: false},
                  {name: 'ИИ', id: true},
                ]"
                :getVal="getValIsAuto"
                style="margin-top:17px;"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <Carusel-Button
                label="Подтвержденные (ИИ)"
                :type="'general'"
                :items="[
                  {name: 'Все', id: null},
                  {name: 'Подтверждённые', id: true},
                  {name: 'Не подтвержденные', id: false},
                ]"
                :getVal="getValIsConfirmed"
                style="margin-top:17px;"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <Carusel-Button
                label="Корректные (ИИ)"
                :type="'general'"
                :items="[
                  {name: 'Все', id: null},
                  {name: 'Корректные', id: true},
                  {name: 'Некорректные', id: false},
                ]"
                :getVal="getValIsValid"
                style="margin-top:17px;"
              />
            </v-col>

            <v-col align="right">
              <v-btn
                color="success"
                class="mt-3"
                @click="loadReportBtn"
              >Поиск</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>

    <!-- Результаты -->
    <v-card class="my-5">
      <!-- Создать отзыв -->
      <v-row>
        <v-col class="ml-2">
          <v-btn
            dark
            color="green"
            @click="showAddComplaint = true"
          >
            <v-icon>mdi-plus</v-icon>Создать отзыв
          </v-btn>
        </v-col>
      </v-row>

      <!-- Пагинация над таблицей -->
      <v-row>
        <v-col cols="auto" class="mb-2" >
          <v-badge
            v-if="meta.total && meta.total !== null"
            bordered
            color="success"
            overlap
            class="mr-7 ml-2"
          >
            <template #badge>
              <span>{{ meta.total }}</span>
            </template>

            <v-chip
              color="success"
              label
              outlined
            >Всего отзывов</v-chip>
          </v-badge>

          <v-badge
            v-if="totalDurationMin !== null"
            bordered
            color="success"
            overlap
            class="mr-7 ml-2"
          >
            <template #badge>
              <span>{{ totalDurationMin }}</span>
            </template>

            <v-chip
              color="success"
              label
              outlined
            >Прослушано минут</v-chip>
          </v-badge>
        </v-col>
        <v-col
          v-if="meta.current_page && meta.last_page && meta.last_page > 1"
          cols="4"
        >
          <v-pagination
            v-model="meta.current_page"
            :total-visible="7"
            :length="meta.last_page"
            @input="pageChange"
          />
        </v-col>
      </v-row>

      <v-data-table
        :headers="report.headers"
        :items="report.items"
        :items-per-page="report.items.length"
        :loading="tableLoading"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        must-sort
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        dense
        hide-default-footer
        @update:options="handleSorting"
      >

        <template #[`item.date`]="{ item }">
          <v-tooltip right max-width="400">
            <template #activator="{ on }">
              <div v-on="on">{{ getReportDate(item) }}</div>
            </template>
            <p class="ma-0 pa-0">Дата создания: {{ item.created_at }} </p>
            <p class="ma-0 pa-0">Дата звонка: {{ item.call_date }} </p>
          </v-tooltip>
        </template>

        <template #[`item.gate_project`]="{ item }">
          {{ item.gate_project.name }}
        </template>

        <template #[`item.kln`]="{ item }">
          <v-chip
            v-if="item.kln != null"
            :color="item.kln_color"
            small
            dark
            class="font-weight-black"
          >{{ item.kln }}</v-chip>
        </template>

        <template #[`item.operator`]="{ item }">
          <div class="d-flex align-center">
            <v-tooltip v-if="item.isMining" bottom max-width="400">
              <template #activator="{ on }">
                <div v-on="on">
                  <v-icon color="green">mdi-checkbox-marked</v-icon>
                </div>
              </template>
              <span>Отработано {{ item.mining_date }}</span>
            </v-tooltip>
            <v-tooltip v-else bottom max-width="400">
              <template #activator="{ on }">
                <div v-on="on">
                  <v-btn
                    color="green"
                    icon
                    :disabled="item.mining_date_write === false"
                    @click="openMiningDialog(item)"
                  >
                    <v-icon>mdi-checkbox-blank-outline</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Не отработано</span>
            </v-tooltip>


            <span style="text-wrap: nowrap;">
              <span v-if="item.sip">[{{item.sip}}]</span> &nbsp; <span v-if="item.gate_user && item.gate_user.full_name">{{ item.gate_user.full_name }}</span>
            </span>
          </div>
        </template>

        <template #[`item.complaint`]="{ item }">
          <p class="ma-0 pa-0 pb-1">
            <strong>Тип:</strong> {{item.type}}
          </p>

          <p v-if="item.criterias.length" class="ma-0 pa-0 pb-1">
            <strong class="mr-2">Критерии:</strong>
            <span v-for="(criteria, index) in item.criterias" :key="index + utils.randomString()">{{criteria}}<br></span>
          </p>

          <p v-if="item.comment" class="ma-0 pa-0 pb-1">
            <strong>Коммент:</strong> {{item.comment}}
          </p>

          <p class="ma-0 pa-0 pb-1">
            <strong>Автор:</strong> <span class="font-italic">{{item.author}}</span>
          </p>
        </template>

        <template #[`item.ai_analysis_status`]="{ item }">
          <v-tooltip v-if="item.ai_analysis_status === 'is_correct'" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" color="success">mdi-check</v-icon>
            </template>
            <span>Корректен</span>
          </v-tooltip>
          <v-tooltip v-else-if="item.ai_analysis_status === 'is_incorrect'" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" color="red">mdi-close</v-icon>
            </template>
            <span>Некорректен</span>
          </v-tooltip>
        </template>

        <template #[`item.calibration_status`]="{ item }">
          <div v-if="item.calibration_comment">
            <v-tooltip v-if="item.calibration_status === true" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on" color="success">mdi-check</v-icon>
              </template>
              <span>{{ item.calibration_comment }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="item.calibration_status === false" bottom>
              <template #activator="{ on }">
                <v-icon v-on="on" color="red">mdi-close</v-icon>
              </template>
              <span>{{ item.calibration_comment }}</span>
            </v-tooltip>
          </div>

          <div v-else>
            <v-icon v-if="item.calibration_status === true" color="success">mdi-check</v-icon>
            <v-icon v-if="item.calibration_status === false" color="red">mdi-close</v-icon>
          </div>
        </template>

        <template #[`item.action`]="{ item, index }">
          <div class="d-flex">
            <!-- Редактировать отзыв -->
            <v-tooltip color="green" bottom max-width="400">
              <template #activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  :disabled="item.complaint_update == false"
                  @click="openEditDialog(item)"
                >
                  <v-icon color="green">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Редактировать</span>
            </v-tooltip>

            <!-- Прослушать звонок -->
            <v-tooltip color="purple" bottom max-width="400">
              <template #activator="{ on: onTooltip }">
                <v-menu
                  v-model="vMenuOpen[index]"
                  :close-on-click="false"
                  :close-on-content-click="false"
                  :disabled="item.uid == null"
                  absolute
                  left
                  style="max-width: 600px"
                  @input="openMenu($event, index)"
                >
                  <template v-slot:activator="{ on: onMenu }">
                    <v-btn  v-on="{...onTooltip, ...onMenu}" icon :disabled="item.uid == null">
                      <v-icon color="purple">mdi-account-tie-voice</v-icon>
                    </v-btn>
                  </template>

                  <v-sheet width="150" class="d-flex justify-end">
                    <v-btn
                      icon
                      small
                      @click="closeMenu(index)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-sheet>

                  <Mini-Audio-Player
                    v-if="vMenuOpen[index]"
                    :callUid="item.uid"
                  />
                </v-menu>
              </template>
              <span>Прослушать звонок</span>
            </v-tooltip>

            <!-- Инфа по звонку -->
            <v-tooltip color="blue" bottom max-width="400">
              <template #activator="{ on }">
                <v-btn
                  v-on="on"
                  :to="{name: 'SpeechAnalysisCall', params: {uid: item.uid,}}"
                  :disabled="item.uid == null"
                  active-class="cheat_active_link"
                  icon
                  target="_blank"
                >
                  <v-icon color="blue">mdi-phone</v-icon>
                </v-btn>
              </template>
              <span>Посмотреть информацию по звонку (откроется в новой вкладке)</span>
            </v-tooltip>

            <!-- Карточки -->
            <v-tooltip color="green" bottom max-width="400">
              <template #activator="{ on }">
                <v-btn
                  :disabled="!item.call_cards || !item.call_cards.length"
                  v-on="on"
                  icon
                  @click="openCallCardDialog(item)"
                >
                  <v-icon color="green">mdi-form-select</v-icon>
                </v-btn>
              </template>
              <span>Показать карточки звонка</span>
            </v-tooltip>

            <!-- Удалить отзыв -->
            <v-tooltip color="red" bottom max-width="400">
              <template #activator="{ on }">
                <v-btn
                  v-on="on"
                  :disabled="item.complaint_delete === false"
                  icon
                  @click="openDeleteDialog(item)"
                >
                  <v-icon color="red">mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>Удалить отзыв</span>
            </v-tooltip>
          </div>
        </template>

      </v-data-table>

      <!-- Пагинация под таблицей -->
      <v-row>
        <v-col cols="4">
          <v-pagination
            v-if="meta.current_page && meta.last_page && meta.last_page > 1"
            v-model="meta.current_page"
            :total-visible="7"
            :length="meta.last_page"
            @input="pageChange"
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Модалка карточки звонка -->
    <v-dialog
      v-model="showCallCardDialog"
      width="500"
    >
      <v-card>
        <v-card-title>Карточки</v-card-title>

        <v-tabs v-model="formTab">
          <v-tab
            v-for="form in forms"
            :key="`form_${form.uniqueId}`"
          >{{ form.title }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="formTab">
          <v-tab-item
            v-for="form in forms"
            :key="`form_tab_${form.uniqueId}`"
          >
            <v-card>
              <v-card-text class="pt-0">
                <v-simple-table dense>
                  <tbody>
                    <tr v-for="field in form.data" :key="`form_field_${form.uniqueId}-${field.code}`">
                      <td><b>{{ field.title }}</b></td>
                      <td>{{ field.value }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>

          </v-tab-item>
        </v-tabs-items>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue"
            text
            @click="closeCallCardDialog"
          >Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Модалка отработки -->
    <v-dialog
      v-model="showMiningDialog"
      width="500"
    >
      <v-card>
        <v-card-title>Отработать звонок?</v-card-title>

        <v-card-text>Будет записано время отработки</v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            @click="closeMiningDialog"
          >Отмена</v-btn>
          <v-btn
            color="green"
            @click="setMining"
          >Да</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Модалка создания отзыва -->
    <v-dialog
      v-model="showAddComplaint"
      persistent
      scrollable
      width="800"
    >
      <v-card :loading="loadingAddComplaintModal">
        <v-card-title>Создание отзыва
          <v-spacer />
          <v-btn icon @click="showAddComplaint = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="complaintForm">
            <ProjectSelector v-model="addComplaint.project" single @input="setQuestionnaires" />

            <UserSelector v-model="addComplaint.agents" single />

            <div v-if="!questionnaireDoesntBound">

              <v-select
                :items="questionnaireTypesList"
                v-model="addComplaint.type_id"
                item-text="label"
                item-value="id"
                no-data-text="Ничего не найдено"
                label="Выберите тип анкеты"
                class="mb-7"
              />

              <v-expansion-panels v-if="criteriasList.length" class="mb-2">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Критерии
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        v-for="criteria in criteriasList"
                        :key="criteria.id"
                        cols="12"
                        xs="12"
                        class="py-0 my-0"
                      >
                        <v-checkbox
                          v-model="addComplaint.criterias"
                          :label="criteria.title"
                          :value="criteria.id"
                          class="py-0 my-0"
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>


              <v-checkbox
                v-model="addComplaint.notify_operator"
                label="Уведомлять оператора"
                class="py-0 my-0"
                dense
              />

              <v-checkbox
                v-model="addComplaint.skip_calculation "
                label="Не расчитывать клн"
                class="py-0 my-0"
                dense
              />

              <v-textarea
                label="Комментарий"
                v-model="addComplaint.comment"
              />
            </div>

            <div v-else>Не найдено анкет</div>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            @click="showAddComplaint = false"
          >Отмена</v-btn>
          <v-btn
            color="green"
            @click="saveComplaint"
          >Создать</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Модалка редактирования -->
    <v-dialog
      v-model="showEditDialog"
      width="500"
    >
      <v-card>
        <v-card-title>Редактирование отзыва</v-card-title>

        <v-card-text v-if="selectedItemEditLoaded">
          <v-expansion-panels v-if="criteriasList.length" class="mb-2">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Критерии
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col
                    v-for="criteria in criteriasList"
                    :key="criteria.id"
                    cols="12"
                    xs="12"
                    class="py-0 my-0"
                  >
                    <v-checkbox
                      v-model="selectedItemEdit.criteria_ids"
                      :label="criteria.title"
                      :value="criteria.id"
                      class="py-0 my-0"
                      dense
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>


          <v-checkbox
            v-model="selectedItemEdit.notify_operator"
            label="Уведомлять оператора"
            class="py-0 my-0"
            dense
          />

          <v-checkbox
            v-model="selectedItemEdit.skip_calculation "
            label="Не расчитывать клн"
            class="py-0 my-0"
            dense
          />

          <v-textarea
            label="Комментарий"
            v-model="selectedItemEdit.comment"
          />
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            @click="closeEditDialog"
          >Отмена</v-btn>
          <v-btn
            color="success"
            @click="editComplaint"
          >Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Модалка удаления -->
    <v-dialog
      v-model="showDeleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title>Удаление отзыва</v-card-title>

        <v-card-text>ТОЧНО УДАЛИТЬ ОТЗЫВ???</v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            @click="closeDeleteDialog"
          >Отмена</v-btn>
          <v-btn
            color="red"
            @click="deleteEntry"
          >УДАЛИТЬ!</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import moment from 'moment'

import { mapActions, mapGetters } from 'vuex'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector'
import UserSelector from '~/components/partials/selectors/UserSelector'
import MiniAudioPlayer from '~/components/partials/MiniAudioPlayer.vue'

export default {
  name: 'ComplaintsReport',
  components: {
    ProjectSelector,
    UserSelector,
    MiniAudioPlayer,
  },

  data() {
    return {
      date: {},
      periodType: 'creation_period',
      savedPeriodType: '',
      projects: [],
      agents: [],
      authors: [],
      complaintsTypes: [],
      questionnaires: [],
      questionnairesLoading: false,
      duration: {
        from: 0,
        to: 7200,
      },
      klnScore: [0, 100],
      onlyUnread: false,
      onlyMining: false,
      onlyTransfered: false,
      calibrate: 'all',
      page: 1,
      tableLoading: false,
      showDeleteDialog: false,
      deletingId: null,
      showCallCardDialog: false,
      formTab: null,
      forms: [],
      showMiningDialog: false,
      selectedItem: null,
      sortBy: 'date',
      sortDesc: true,
      vMenuOpen: [],
      showAddComplaint:false,
      addComplaint: {
        project: [],
        agents: [],
        criterias: [],
        notify_operator: true,
        skip_calculation: false,
        comment: null,

        questionnaire_id: null,
        type_id: null,
      },
      showEditDialog: false,
      selectedItemEdit: null,
      questionnaireDoesntBound: true,
      criteriasList: [],
      questionnaireTypesList: [],
      loadingAddComplaintModal: false,
      selectedItemEditLoaded: false,
      totalDuration: null,

      filters: {
        isAuto: null,
        isValid: null,
        isConfirmed: null,
      },

      report: {
        items: [],
        headers: [
          {text: '№', value: 'id', sortable: false},
          {text: 'Дата', value: 'date', sortable: false},
          {text: 'Проект', value: 'gate_project', sortable: false},
          {text: 'КЛН', value: 'kln', sortable: false},
          {text: 'Оператор', value: 'operator', sortable: false},
          {text: 'Отзыв', value: 'complaint', sortable: false},
          {text: 'ИИ Анализ', value: 'ai_analysis_status', sortable: false},
          {text: 'Калибровка', value: 'calibration_status', sortable: false},
          {text: '', value: 'action', sortable: false},
        ],
      }
    }
  },

  computed: {
    ...mapGetters({
      complaintsReport: 'complaints_report/complaintsReport',
      meta: 'shared/meta',
    }),

    addComplaintKLN() {
      // depricated
      let kln = 0

      this.addComplaint.criterias.forEach(item => {
        const criterial = this.criteriasList.find(criteriaItem => criteriaItem.id === item)
        if (criterial !== undefined) kln -= criterial.weight
      })

      if (kln < 0) kln = 0

      return kln
    },

    totalDurationMin() {
      if (this.totalDuration && typeof this.totalDuration === 'number') {
        if (this.totalDuration === 0) return 0
        return Math.floor(this.totalDuration / 60)
      }
      return null
    },
  },

  watch: {
    // async projects(val) {
    //   this.questionnairesLoading = true
    //   let res = await this.loadQuestionnaires(val)
    //   this.questionnaires = res.map(el => ({id: el, name: el}))
    //   this.complaintsTypes = []
    //   this.questionnairesLoading = false
    // },
  },

  methods: {
    ...mapActions({
      loadComplaintsReportItems: 'complaints_report/loadComplaintsReportItems',
      loadQuestionnaires: 'complaints_report/loadQuestionnaires',
      setMiningDate: 'complaints_report/setMiningDate',
      loadQuestionnairesByProject: 'reports_speech_analysis/loadQuestionnaires',
      loadProjects: 'graphql/loadProjects',
      loadQuestionnaireTypes: 'reports_speech_analysis/loadQuestionnaireTypes',
      loadCriteriaList: 'reports_speech_analysis/loadCriteriaList',
      createcomplaints: 'reports_speech_analysis/createcomplaints',
      loadComplaint: 'reports_speech_analysis/loadComplaint',
      destroyСomplaint: 'reports_speech_analysis/destroyСomplaint',
      updateComplaint: 'reports_speech_analysis/updateComplaint',
      loadWiretappingTotalDuration: 'complaints_report/loadWiretappingTotalDuration',
    }),

    getValPeriodType(data) {
      this.periodType = data
    },

    getValCalibrate(data) {
      this.calibrate = data
    },

    getValIsAuto(data) {
      this.filters.isAuto = data
    },

    getValIsValid(data) {
      this.filters.isValid = data
    },

    getValIsConfirmed(data) {
      this.filters.isConfirmed = data
    },

    getReportDate(item) {
      let date = ''
      if (this.savedPeriodType === 'creation_period') date = item.created_at
      else if (this.savedPeriodType === 'call_period') date = item.call_date
      return date
    },

    openDeleteDialog(item) {
      this.deletingId = item.id
      this.showDeleteDialog = true
    },

    closeDeleteDialog() {
      this.deletingId = null
      this.showDeleteDialog = false
    },

    deleteEntry() {
      this.destroyСomplaint({ complaintId: this.deletingId })
      this.closeDeleteDialog()
      this.loadReport()
    },

    openCallCardDialog(item) {
      this.forms = item?.call_cards.map(el => ({
        id: el.form_id,
        uniqueId: this.utils.randomString(),
        title: el.form?.title,
        data:JSON.parse(el.data),
      }))
      this.showCallCardDialog = true
    },

    closeCallCardDialog() {
      this.showCallCardDialog = false
    },

    openMiningDialog(item) {
      this.selectedItem = item
      this.showMiningDialog = true
    },

    closeMiningDialog() {
      this.selectedItem = null
      this.showMiningDialog = false
    },

    async setMining() {
      const payload = {
        complaintId: this.selectedItem.id,
        source: this.selectedItem.source,
      }

      await this.setMiningDate(payload)
      this.closeMiningDialog()
      this.loadReport()
    },

    pageChange(page) {
      this.page = page
      this.loadReport()
    },

    openMenu(isOpening, index) {
      this.vMenuOpen.forEach((el, index) => {
        if (el) this.vMenuOpen[index] = false
      })
      this.vMenuOpen[index] = true
      this.$forceUpdate()
    },

    closeMenu() {
      this.vMenuOpen.forEach((el, index) => {
        this.vMenuOpen[index] = false
      })
      this.$forceUpdate()
    },


    loadReportBtn() {
      this.page = 1
      this.loadReport()
    },

    handleSorting(ev) {
      if (
        this.sortBy === ev.sortBy[0]
        && this.sortDesc === ev.sortDesc[0]
      ) return
      this.sortBy = ev.sortBy[0]
      this.sortDesc = ev.sortDesc[0]
      this.loadReport()
    },

    async setQuestionnaires() {
      this.addComplaint.questionnaire_id = null
      this.addComplaint.criterias = []
      this.criteriasList.length = 0

      if (this.addComplaint.project.length === 0) return
      this.loadingAddComplaintModal = true

      let graphQuery = {
        query: `{
          projects(id: ${this.addComplaint.project.at(-1)}) {
            questionnaire {
              id
            }
          }
        }`
      }

      this.addComplaint.questionnaire_id = await this.loadProjects(graphQuery)
        .then(response => response[0].questionnaire?.id)

      if (!this.addComplaint.questionnaire_id) {
        this.questionnaireDoesntBound = true
        this.loadingAddComplaintModal = false
        return
      }
      this.questionnaireDoesntBound = false

      this.loadQuestionnaireTypes()
        .then(data => { this.questionnaireTypesList = data })

      this.loadCriteriaList(this.addComplaint.questionnaire_id)
       .then(data => { this.criteriasList = data })

      this.loadingAddComplaintModal = false

      // this.loadQuestionnairesByProject(this.addComplaint.project.at(-1))
    },

    async saveComplaint() {
      if (!this.$refs.complaintForm.validate()) return

      let payload = {
        project_id: this.addComplaint.project.at(-1),
        user_id: this.addComplaint.agents.at(-1),
        comment: this.addComplaint.comment,
        questionnaire_id: this.addComplaint.questionnaire_id,
        type_id: this.addComplaint.type_id,
        criteria_ids: this.addComplaint.criterias,
        notify_operator: this.addComplaint.notify_operator,
        skip_calculation: this.addComplaint.skip_calculation,
      }

      try {
        this.loadingAddComplaintModal = true
        await this.createcomplaints(payload)

        this.addComplaint.project = []
        this.addComplaint.agents = []
        this.addComplaint.questionnaire_id = null
        this.addComplaint.type_id = null
        this.addComplaint.criterias = []
        this.addComplaint.notify_operator = true
        this.addComplaint.skip_calculation = false
        this.addComplaint.comment = null
        this.showAddComplaint = false
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingAddComplaintModal = false
      }

    },

    async openEditDialog(item) {
      this.selectedItemEditLoaded = false
      this.selectedItemEdit = await this.loadComplaint(item.id)
      this.criteriasList = await this.loadCriteriaList(this.selectedItemEdit.questionnaire_id)

      this.selectedItemEditLoaded = true
      this.showEditDialog = true
    },

    closeEditDialog() {
      this.showEditDialog = false
      this.selectedItemEdit = null
      this.selectedItemEditLoaded = false
      this.loadReport()
    },

    async editComplaint() {
      this.selectedItemEditLoaded = false
      let payload = {
        complaintId: this.selectedItemEdit.id,
        questionnaire_id: this.selectedItemEdit.questionnaire_id,
        type_id: this.selectedItemEdit.type_id,
        criteria_ids: this.selectedItemEdit.criteria_ids,
        comment: this.selectedItemEdit.comment,
        not_notify_operator: this.selectedItemEdit.not_notify_operator,
        skip_calculation: this.selectedItemEdit.skip_calculation,
      }

      if (this.selectedItemEdit.uid) {
        payload.uid = this.selectedItemEdit.uid
      } else {
        payload.user_id = this.selectedItemEdit.user_id
        payload.project_id = this.selectedItemEdit.project_id
      }
      await this.updateComplaint(payload)

      this.closeEditDialog()
    },

    loadTotalDuration() {
      const payload = {
        [this.periodType]: [
          moment(this.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.date.end).format('YYYY-MM-DD HH:mm:ss')
        ],
        projects: this.projects,
        authors: this.authors,
        users: this.agents,
        duration_range: [
          this.duration.from,
          this.duration.to,
        ],
        kln_range: this.klnScore,
        type_ids: this.complaintsTypes,
      }

      if (this.filters.isAuto !== null) {
        payload.is_gpt = this.filters.isAuto
      }

      this.loadWiretappingTotalDuration(payload)
        .then(response => {
          this.totalDuration = response.data.total_sec_duration
        })
    },

    filtersFromQuery() {
      const filters = this.$route.query

      if (!filters.project_ids) return

      this.klnScore[0] = 0
      this.klnScore[1] = 99

      if (Array.isArray(filters.period)) {
        this.date.start = new Date(filters.period[0])
        this.date.end = new Date(filters.period[1])
      }

      if (filters.period_type === 'call') {
        this.$refs['period_type'].setNextVal()
      }

      if (Array.isArray(filters.project_ids)) {
        for (const projectId of filters.project_ids) {
          this.projects.push(parseInt(projectId))
        }
      } else if (typeof filters.project_ids === 'string') {
        this.projects.push(parseInt(filters.project_ids))
      }

      if (Array.isArray(filters.type_ids)) {
        for (const typeId of filters.type_ids) {
          this.complaintsTypes.push(parseInt(typeId))
        }
      } else if (typeof filters.type_ids === 'string') {
        this.complaintsTypes.push(parseInt(filters.type_ids))
      }

      if (Array.isArray(filters.author_ids)) {
        for (const authorId of filters.author_ids) {
          this.authors.push(parseInt(authorId))
        }
      } else if (typeof filters.author_ids === 'string') {
        this.authors.push(parseInt(filters.author_ids))
      }

      if (Array.isArray(filters.duration_range)) {
        this.duration.from = parseInt(filters.duration_range[0])
        this.duration.to = parseInt(filters.duration_range[1])
      }

      if ('is_auto' in filters) this.filters.isAuto = filters.is_auto === 'false' ? false : true
      if ('only_transfered' in filters) this.onlyTransfered = filters.only_transfered === 'false' ? false : true

      if ('user_id' in filters) {
        this.agents.push(parseInt(filters.user_id))
      }

      this.loadReport()
    },

    async loadReport() {
      if (!this.$refs.form.validate()) return
      this.closeMenu()
      this.tableLoading = true
      this.savedPeriodType = this.periodType

      let payload = {
        period: [
          moment(this.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.date.end).format('YYYY-MM-DD HH:mm:ss')
        ],
        periodType: this.periodType,
        projects: this.projects,
        agents: this.agents,
        authors: this.authors,
        duration: this.duration,
        klnScore: this.klnScore,
        // onlyUnread: this.onlyUnread,
        // onlyMining: this.onlyMining,
        onlyTransfered: this.onlyTransfered,
        page: this.page,
        types: this.complaintsTypes,
        sort: {by: this.sortBy, desc: this.sortDesc},
      }

      if (this.filters.isAuto !== null) {
        payload.isAuto = this.filters.isAuto;
      }

      if (this.filters.isValid !== null) {
        payload.isValid = this.filters.isValid;
      }

      if (this.filters.isConfirmed !== null) {
        payload.isConfirmed = this.filters.isConfirmed;
      }

      try {
        this.loadTotalDuration()
        let res = await this.loadComplaintsReportItems(payload)
        let items = res.data.map(item => {
          let isMining = item.mining_date ? true : false
          this.$set(item, 'isMining', isMining)
          return item
        })
        this.report.items = items
      } catch (error) {
        console.error(error)
      } finally {
        this.tableLoading = false
      }
    },
  },

  async mounted() {
    this.questionnaires = await this.loadQuestionnaires()

    if (this.$route.query['project_id'] === undefined) return;

    this.projects.push(Number(this.$route.query['project_id']));

    if (this.$route.query['is_auto'] !== undefined) {
      if (this.$route.query['is_auto'] === 'true') this.filters.isAuto = true
      else if (this.$route.query['is_auto'] === 'false') this.filters.isAuto = false
      else this.filters.isAuto = null
    }

    if (this.$route.query['is_valid'] !== undefined) {
      if (this.$route.query['is_valid'] === 'true') this.filters.isValid = true
      else if (this.$route.query['is_valid'] === 'false') this.filters.isValid = false
      else this.filters.isValid = null
    }

    if (this.$route.query['is_confirmed'] !== undefined) {
      if (this.$route.query['is_confirmed'] === 'true') this.filters.isConfirmed = true
      else if (this.$route.query['is_confirmed'] === 'false') this.filters.isConfirmed = false
      else this.filters.isConfirmed = null
    }

    this.loadReport();
  },

  created() {
    let period = this.$route.query.period

    if (Array.isArray(period)) {
      this.date.start = new Date(period[0])
      this.date.end = new Date(period[1])
    }

    period = this.$route.query['period[]'];

    if (period === undefined) return;

    if (Array.isArray(period)) {
      this.date.start = new Date(period[0])
      this.date.end = new Date(period[1])
    }
  }
}
</script>

<style scoped>
.cheat_active_link::before {
  opacity: 0;
}
</style>
